import { render, staticRenderFns } from "./adminSubmitButton.vue?vue&type=template&id=5e5d19e5&scoped=true"
import script from "./adminSubmitButton.vue?vue&type=script&lang=js"
export * from "./adminSubmitButton.vue?vue&type=script&lang=js"
import style0 from "./adminSubmitButton.vue?vue&type=style&index=0&id=5e5d19e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5d19e5",
  null
  
)

export default component.exports